import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import modalStore from 'Stores/modalStore'
import SmartFilter from '../../Filter/SmartFilter'
import styles from './SendDocument.module.scss'

const SendDocument = () => {
  const { changeValues, data } = modalStore
  const [selectedClients, setSelectedClients] = useState([])

  const onChangeClient = (e) => {
    const selectedClient = e[0]
    if (!selectedClient) return

    const clientId = Number(selectedClient.profile.id)
    const clientName = selectedClient.profile.full_name

    const isAlreadySelected = selectedClients.some(
      (client) => client.id === clientId,
    )

    if (!isAlreadySelected) {
      const newSelectedClients = [
        ...selectedClients,
        {
          id: clientId,
          name: clientName,
          profile: selectedClient.profile,
        },
      ]

      setSelectedClients(newSelectedClients)

      const clientIds = newSelectedClients.map((client) => client.id)
      changeValues(clientIds, data.fieldName)
    }
  }

  const removeClient = (clientId) => {
    const updatedClients = selectedClients.filter(
      (client) => client.id !== clientId,
    )
    setSelectedClients(updatedClients)

    const clientIds = updatedClients.map((client) => client.id)
    changeValues(clientIds, data.fieldName)
  }

  return (
    <div className={styles.box}>
      <SmartFilter
        link={data.fieldLink}
        placeholder={`Вводите имя, e-mail или телефон ${data.user}а`}
        new_key='full_name'
        sub_key='profile'
        backFunction={onChangeClient}
      />

      {selectedClients.length > 0 && (
        <ul className={styles.list}>
          <li className={styles.item}>
            Выбранные клиенты ({selectedClients.length}):
          </li>
          {selectedClients.map((client) => (
            <li key={client.id} className={styles.clientItem}>
              <span>{client.name}</span>
              <button
                type='button'
                className={styles.removeBtn}
                onClick={() => removeClient(client.id)}
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default observer(SendDocument)
